import { render, staticRenderFns } from "./ETMIVacuna.vue?vue&type=template&id=6cfead63&scoped=true"
import script from "./ETMIVacuna.vue?vue&type=script&lang=js"
export * from "./ETMIVacuna.vue?vue&type=script&lang=js"
import style0 from "./ETMIVacuna.vue?vue&type=style&index=0&id=6cfead63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfead63",
  null
  
)

export default component.exports